/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { AnalyticsResultFormatterMessage } from '../../../messages/analytics-result-formatter.message';

export const triggerActualPoliciesCount = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as AnalyticsResultFormatterMessage;
  const template = message?.template?.layout[0]?.colProps;
  const found = template?.find(
    (o: any) => o.key === 'totalSupplyChainTemplates'
  );
  if (found?.compProps?.appCardList && found?.compProps?.appCardList[0]) {
    found.compProps.appCardList[0].value =
      message?.raw?.totalSupplyChainTemplates?.raw;
  }
  return true;
};
